import { useCallback, useState } from "react";

export function serializeSort(sorts = []) {
  return sorts.map((sort) => `${sort.key}:${sort.direction}`).join(",");
}

export function withSort(filters = {}, tableSort) {
  if (!tableSort?.sortQuery) {
    return filters;
  }

  return {
    ...filters,
    sort: tableSort.sortQuery,
  };
}

function cycleSort(sorts, key) {
  const index = sorts.findIndex((sort) => sort.key === key);

  if (index === -1) {
    return [...sorts, { key, direction: "asc" }];
  }

  if (sorts[index].direction === "asc") {
    return sorts.map((sort, i) =>
      i === index ? { key, direction: "desc" } : sort
    );
  }

  return sorts.filter((_, i) => i !== index);
}

export default function useTableSort() {
  const [sorts, setSorts] = useState([]);

  const toggleSort = useCallback((key) => {
    if (!key) return;
    setSorts((prev) => cycleSort(prev, key));
  }, []);

  const clearSort = useCallback(() => {
    setSorts([]);
  }, []);

  return {
    sorts,
    sortQuery: serializeSort(sorts),
    toggleSort,
    clearSort,
    hasSort: sorts.length > 0,
  };
}
